import svg from './introSVG'
import { gsap } from 'gsap'
import { Colours } from '../constants';
const { green, pink, yellow, orange, white } = Colours;

export default class IntroSequence {

    constructor(onComplete) {

        // Check the cookie first
        // const showIntro = Boolean(window.AppData.showIntro);

        // if (!showIntro) {
        //     return;
        // }

        this.onComplete = onComplete;

        this.element = document.createElement('div');
        this.element.className = 'fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center transition duration-1000 ease-in-out intro-sequence';

        const stage = document.createElement('div');
        stage.className = 'w-3/4';
        stage.innerHTML = svg;
        this.element.appendChild(stage);

        this.dotRects = [];
        this.showBg = true;

        document.body.appendChild(this.element);

        for (let i = 1; i <= 4; i++) {
            const dot = document.querySelector(`#dot${i}`);
            this.dotRects.push(dot.getBoundingClientRect());
        }

        this.canvas = document.createElement('canvas');
        this.canvas.className = 'fixed top-0 bottom-0 left-0 right-0 z-50';
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.ctx = this.canvas.getContext('2d');
        this.element.appendChild(this.canvas);

        this.dotRadius = this.dotRects[0].width / 2;

        this.start();
    }

    start() {
        const dotRadius = this.dotRects[0].width * 4;
        const w = window.innerWidth;
        const h = window.innerHeight;

        const randX = Math.random() * w;
        const randY = Math.random() * h;

        this.dots = [
            {
                x: -dotRadius * 2,
                y: randY,
                radius: dotRadius,
                rgba: { ...green },
            },
            {
                x: w + dotRadius,
                y: h - randY,
                radius: dotRadius,
                rgba: { ...yellow },
            },
            {
                x: randX,
                y: -dotRadius * 2,
                radius: dotRadius,
                rgba: { ...pink },
            },
            {
                x: w - randX,
                y: h + dotRadius * 2,
                radius: dotRadius,
                rgba: { ...orange },
            },
            {
                x: w / 2,
                y: h / 2,
                radius: dotRadius,
                rgba: { r: 255, g: 255, b: 255, a: 0 },
            }
        ]

        this.animate = this.animate.bind(this);
        this.animate();

        this.runSequence();
    }

    runSequence() {
        const duration = 1.5;

        gsap.to(this.dots[0], {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            duration,
            ease: 'power4.in',
            onComplete: () => this.explode()
        });

        gsap.to(this.dots[1], {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            duration,
            ease: 'power3.in'
        });

        gsap.to(this.dots[2], {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            duration,
            ease: 'power2.in',
        });

        gsap.to(this.dots[3], {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            duration,
            ease: 'power4.in',
        });
    }

    explode() {
        // do stuff
        this.dots.forEach(d => {
            d.rgba = { ...white }
        });

        // Blow up one of them
        gsap.to(this.dots[4], { radius: Math.max(window.innerWidth, window.innerHeight), duration: 1.5, ease: 'power4.out' });
        gsap.to(this.dots[4].rgba, { a: 0, duration: 1.5, ease: 'power4.out' });

        const { r, g, b } = green;

        for (let i = 0; i < 4; i++) {
            const { x, y, width } = this.dotRects[i];
            const radius = width / 2;
            gsap.to(this.dots[i], { x: x + radius, y: y + radius, radius, duration: 1, ease: 'power3.out', onComplete: i === 0 ? () => this.showStrapline() : () => { } });
            gsap.to(this.dots[i].rgba, { r, g, b, duration: 2 });
        }
    }

    showStrapline() {

        setTimeout(() => {
            this.showBg = false;
            const straplineElements = document.querySelectorAll('.strapline');
            straplineElements.forEach(e => e.classList.add('show'));
        }, 200);

        setTimeout(() => {
            this.fadeDotsToWhite();
            this.onComplete();
        }, 1000);
    }

    fadeDotsToWhite() {
        for(let i = 0; i < this.dots.length; i++) {
            gsap.to(this.dots[i].rgba, { r: 255, g: 255, b:255, duration: 1, ease: 'power2.inOut', onComplete: () => {
                if (i === 0) {
                    cancelAnimationFrame(this.raf);
                    this.raf = null;
                    document.body.classList.add('intro-complete');
                    setTimeout(() => this.canvas.remove(), 100);
                }
            } });
        }
    }

    // showLogo() {
    //     gsap.to(this.dots[0].rgba, { a: 0, duration: 1, ease: 'power2.inOut' });
    //     gsap.to(this.dots[1].rgba, { a: 0, duration: 1, ease: 'power2.inOut' });

    //     // These become the connections dots

    //     const dot5 = this.dotRects[4];
    //     const dot6 = this.dotRects[5];
    //     const r = dot5.width / 2;
    //     const duration = 0.5;

    //     gsap.to(this.dots[2], { x: dot5.x + r, y: dot5.y + r, duration, ease: 'power2.inOut' });
    //     gsap.to(this.dots[3], {
    //         x: dot6.x + r, y: dot6.y + r, duration, ease: 'power2.inOut', onComplete: () => {
    //             const logoElements = document.querySelectorAll('.logo');
    //             logoElements.forEach(e => e.classList.add('show'));
    //             setTimeout(() => this.finish(), 1500);
    //         }
    //     });

    //     document.querySelector('#fortheloveof').classList.remove('show');
    // }

    // finish() {
    //     console.log("finish");
    //     const duration = 1;
    //     gsap.to(this.dots[2], { x: 0, y: 0, duration, ease: 'power2.inOut' });
    //     gsap.to(this.dots[2].rgba, { a: 0, duration, ease: 'power2.inOut' });

    //     gsap.to(this.dots[3], { x: 0, y: 0, duration, ease: 'power2.inOut' });
    //     gsap.to(this.dots[3].rgba, {
    //         a: 0, duration, ease: 'power2.inOut', onComplete: () => {
    //             this.ctx.canvas.remove();
    //             this.element.remove();
    //             cancelAnimationFrame(this.raf);
    //             this.raf = null;
    //             console.log("Calling onComplete");
    //             this.onComplete();
    //         }
    //     });

    //     this.element.classList.add('opacity-0');
    // }

    animate() {
        if (this.showBg) {
            this.ctx.rect(0, 0, window.innerWidth, window.innerHeight);
            this.ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
            this.ctx.fill();
        } else {
            this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        }

        for (let i = 0; i < this.dots.length; i++) {
            this.render(this.dots[i]);
        }

        this.raf = requestAnimationFrame(this.animate);
    }

    render({ x, y, radius, rgba }) {
        this.ctx.beginPath();
        const { r, g, b, a } = rgba;
        this.ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a})`;
        this.ctx.arc(x, y, radius, 0, Math.PI * 2);
        this.ctx.fill();
        this.ctx.closePath();
    }
}